/* Custom Claude sections: swipe sliders with arrows and dots. */
(function () {
  if (customElements.get('cc-slider')) return;
  customElements.define('cc-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cc-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-cc-prev]');
      this.next = this.querySelector('[data-cc-next]');
      this.dots = this.querySelector('[data-cc-dots]');
      this.loop = this.hasAttribute('data-loop');
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onScroll = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }
    step() {
      const first = this.track.children[0];
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    go(dir) {
      const t = this.track, max = t.scrollWidth - t.clientWidth;
      let x = t.scrollLeft + dir * this.step();
      if (this.loop) { if (x > max + 2) x = 0; else if (x < -2) x = max; }
      t.scrollTo({ left: Math.max(0, Math.min(max, x)), behavior: 'smooth' });
    }
    update() {
      const t = this.track, max = t.scrollWidth - t.clientWidth, over = max > 2;
      this.toggleAttribute('data-overflow', over);
      if (this.prev) this.prev.disabled = !this.loop && t.scrollLeft <= 2;
      if (this.next) this.next.disabled = !this.loop && t.scrollLeft >= max - 2;
      if (!this.dots) return;
      const st = this.step(), n = over ? Math.round(max / st) + 1 : 0;
      if (this.dots.childElementCount !== n) {
        this.dots.innerHTML = '';
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => t.scrollTo({ left: i * st, behavior: 'smooth' }));
          this.dots.appendChild(b);
        }
      }
      const active = Math.round(t.scrollLeft / st);
      Array.from(this.dots.children).forEach((b, i) => b.toggleAttribute('aria-current', i === active));
    }
  });
})();
